import React from 'react'
import { Box, Grid } from '@mui/material'
import styled from 'styled-components'
import { RoundedButtonStatic, RoundedButtonStaticNodata } from 'components/common/LeftPanel/LeftPanel.styled'
import { Country, MetricGroup, ReportOverViewDataProps } from 'types'
import { formatNumberDecimal, formatNumberPureDecimal } from 'utils/formatNumber'
import { getDataKeyExistsPillar } from 'utils/getDataExistsPillar'
import { PILLAR_INFO } from 'constant'
import { numbersToWords } from 'constant/numberToWord'
import _ from 'lodash'
import { useAppSelector } from 'hooks'

interface IReportOverview {
  data: ReportOverViewDataProps[]
  metricGroups: MetricGroup[]
  countries: Country[]
  yearRange: number[]
}

const Overview: React.FC<IReportOverview> = ({ data, metricGroups, countries, yearRange }) => {
  const existsPillarDataKeys = getDataKeyExistsPillar(metricGroups, countries)
  const { yearFilter } = useAppSelector(({ vibrancy }) => vibrancy.configuration)

  return (
    <>
      <span style={{ paddingLeft: '172px', fontFamily: 'CircularStdMedium' }}>
        {_.capitalize(numbersToWords[yearRange.length])}-Year Overview
      </span>
      <Box sx={{ width: '100%', ml: '36px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '20px' }}>
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              backgroundColor: 'transparent',
              background: 'transparent',
              left: '16px',
            }}
          >
            <Box
              sx={{
                width: '102%',
                height: '1px',
                background: '#eaeaea',
                ml: '-6px',
                position: 'relative',
                top: '80px',
              }}
            ></Box>
            <Grid
              item
              xs={4}
              sx={{ width: '100%', backgroundColor: 'transparent', background: 'transparent', pl: '0px !important' }}
            >
              <OverviewContainer>
                <Header></Header>
                <OverviewBody>
                  {PILLAR_INFO.map((pillar) =>
                    existsPillarDataKeys.includes(pillar.dataKey) ? (
                      <RoundedButtonStatic key={pillar.dataKey}>{pillar.displayName}</RoundedButtonStatic>
                    ) : (
                      <RoundedButtonStaticNodata key={pillar.dataKey}>{pillar.displayName}</RoundedButtonStaticNodata>
                    ),
                  )}
                </OverviewBody>
              </OverviewContainer>
            </Grid>
            {yearRange.map((year, index) => (
              <Grid
                item
                xs={4}
                sx={{ width: '100%', backgroundColor: 'transparent', background: 'transparent', pl: '0px !important' }}
                key={year}
              >
                <OverviewContainer>
                  <Header>
                    <YearHeader>{year}</YearHeader>
                    <BodyContentRow>
                      <TextHeader>Score</TextHeader>
                      <TextHeader>Rank</TextHeader>
                    </BodyContentRow>
                  </Header>
                  <OverviewBody>
                    {index !== 0 && (
                      <Box
                        sx={{ position: 'absolute', height: '100%', width: '1px', background: '#eaeaea', left: '3px' }}
                      ></Box>
                    )}

                    {PILLAR_INFO.map((pillar) =>
                      existsPillarDataKeys.includes(pillar.dataKey) &&
                      year >= Math.min(...(yearFilter?.yearRange ?? 0)) ? (
                        <BodyContentRow key={pillar.dataKey}>
                          <TextHeader>
                            {formatNumberPureDecimal(
                              Number(data[index]?.countryReportData?.[`${pillar.dataKey}Weight`]),
                              2,
                            )}
                          </TextHeader>
                          <TextHeader>
                            {data[index]?.countryReportData?.[`${pillar.dataKey}ShareRanking`] as number}/
                            {data[index]?.totalCountry}
                          </TextHeader>
                        </BodyContentRow>
                      ) : (
                        <BodyContentRow key={pillar.dataKey}>
                          <TextHeader>-</TextHeader>
                          <TextHeader>-</TextHeader>
                        </BodyContentRow>
                      ),
                    )}
                  </OverviewBody>
                </OverviewContainer>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  )
}

export default Overview

const Header = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`
const YearHeader = styled.span`
  background: #c2ddee;
  text-align: center;
  padding: 3px 12px;
`
const TextHeader = styled.span`
  font-size: 12px;
  text-align: center;
  width: 50%;
`
const OverviewBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
`
const BodyContentRow = styled.div`
  width: 100%;
  margin-top: 0.5px;
  display: flex;
  justify-content: space-around;
  padding: 5px 0px;
`
const OverviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
